const prefix = 'routes';

export const i18n = {
    dashboard: {
        id: `${prefix}.dashboard`,
        defaultMessage: 'Dashboard',
    },
    instances: {
        id: `${prefix}.instances`,
        defaultMessage: 'Instances',
    },
    instanceDetail: {
        id: `${prefix}.instanceDetail`,
        defaultMessage: 'Instance',
    },
    instanceSectionDetails: {
        id: `${prefix}.instanceSectionDetails`,
        defaultMessage: 'Details',
    },
    instanceSectionUsers: {
        id: `${prefix}.instanceSectionUsers`,
        defaultMessage: 'Users',
    },
    instanceSectionSubscriptions: {
        id: `${prefix}.instanceSectionSubscriptions`,
        defaultMessage: 'Subscriptions',
    },
    instanceSectionWorkspaces: {
        id: `${prefix}.instanceSectionWorkspaces`,
        defaultMessage: 'Workspaces',
    },
    users: {
        id: `${prefix}.users`,
        defaultMessage: 'Users',
    },
    supportPackages: {
        id: `${prefix}.supportPackages`,
        defaultMessage: 'Support Packages',
    },
    activeVersions: {
        id: `${prefix}.activeVersions`,
        defaultMessage: 'Active Versions',
    },
    activeVersionsDrilldown: {
        id: `${prefix}.activeVersionsDrilldown`,
        defaultMessage: 'Sign-In Details',
    },
    notFoundTitle: {
        id: `${prefix}.notFoundTitle`,
        defaultMessage: 'Page not found',
    },
    notFoundMessage: {
        id: `${prefix}.notFoundMessage`,
        defaultMessage: 'Double check the URL or try again later',
    },
    untitledInstance: {
        id: `${prefix}.untitledInstance`,
        defaultMessage: 'Untitled Instance',
    },
} as const;
